import styled from "styled-components";

export interface IDefaultPanelProps {
  open?: boolean;
}

export const PanelContainer = styled.div<IDefaultPanelProps>`
  display: flex;
  flex-direction: row-reverse;
  background: ${(prop)=>prop.theme.background.surface};
  width: ${(props) => (props.open ? "17rem" : "1.75rem")};
  transition: all 0.75s;
  height: 100%;
  padding-bottom: 5 rem;
`;

export const PanelMainContainer = styled.div<IDefaultPanelProps>`
  display: flex;
  overflow-y: ${(props) => (props.open ? "auto" : "hidden")};
  opacity: ${(props) => (props.open ? 1 : 0)};
  overflow-x: hidden;
  flex-direction: column;
  margin-top: 1.25rem;
  padding-right: 0.5rem;
  padding-bottom: 5rem;
  justify-content: flex-start
  align-items: flex-start
  height: 100%;

  ::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #363537;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #d9d9d9;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const OpenCloseContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;

  svg{
    height:20px;
    width:20px;
    margin:0px 3px;
  }

`;
